@if (userService.user(); as user) {
  <tt-avatar
    data-testid="tt-user-info_button-settings"
    role="button"
    [placeholder]="user | initials"
    [ttMenuDisabled]="disabled()"
    [ttMenuTriggerFor]="menu"
    [ttTooltip]="user | name" />
} @else {
  <div class="tt-user-info_placeholder"></div>
}

<tt-menu #menu [dataTestId]="'tt-user-info_button-settings-menu'">
  <button routerLink="/settings" ttMenuItem>
    <mat-icon [icon]="'settings'" [iconSize]="16" />
    {{ 'Settings' | transloco }}
  </button>
  <button
    *ngxPermissionsOnly="[RolePermissions.editOrganisationSettings]"
    aria-label="Organisation Settings"
    routerLink="/settings/organisation"
    ttMenuItem>
    <mat-icon [icon]="'building'" [iconSize]="16" />
    {{ 'OrganisationSettings' | transloco }}
  </button>
  <button routerLink="/settings/product" ttMenuItem>
    <mat-icon [icon]="'info'" [iconSize]="16" />
    {{ 'ProductInformation' | transloco }}
  </button>
  <button ttMenuItem (click)="onLogout()">
    <mat-icon [icon]="'square-arrow-right'" [iconSize]="16" />
    {{ 'Logout' | transloco }}
  </button>

  <div class="tt-user-info_divider"></div>

  <div class="tt-user-info_organisations">
    <h5 class="tt-user-info_title">{{ 'Organisations' | transloco }}</h5>

    <fieldset aria-label="Select Root Organisation" class="tt-user-info_organisations-fieldset" role="radiogroup">
      @for (organisation of organisationTreeService.rootOrganisations(); track organisation.id) {
        @if (currentRootOrganisationId() === organisation.id) {
          <button
            aria-checked="true"
            class="tt-user-info_organisations-item"
            data-testid="user-info_organisation-menu-item"
            role="radio"
            ttMenuItem
            type="button">
            <span class="tt-user-info_organisations-item-name">{{ organisation.name }}</span>
            <mat-icon
              class="tt-user-info_organisations-item-check-icon"
              data-testid="user-info_organisations-item-check-icon"
              [icon]="'check'"
              [iconSize]="20" />
          </button>
        } @else {
          <button
            aria-checked="false"
            class="tt-user-info_organisations-item"
            data-testid="user-info_organisation-menu-item"
            role="radio"
            ttMenuItem
            type="button"
            (click)="setCurrentRootOrganisation(organisation.id)">
            {{ organisation.name }}
          </button>
        }
      }
    </fieldset>
  </div>
</tt-menu>
